export default __webpack_public_path__ + "static/media/img_23.2714494b.JPG";